import { SliderState } from 'react-stately'

import { createContextAndHook } from '../utils/create-context'

export const [SliderStateContext, useSliderStateContext] =
  createContextAndHook<SliderState>()
